
import Vue from 'vue'

const actions = {

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("comum/vendedor/list-vendedores",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listVendedores = result.data.result;

                return listVendedores;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar vendedores: [${ex}]`
            };
        }
    },
}

export default {
    namespaced: true,
    actions
}
